/* eslint-disable max-statements */
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import './coachingShoutout.scss';

import { useGetActivityEmployeeSearchQuery } from '../../features/coaching/coachingHistoryGrid/coachingHistoryGridSlice';
import {
    selectCurrentEmpid,
    selectCurrentRole,
    selectCurrentUser,
    selectCurrentUserManagerLevel,
    selectIsPseudoSupervisor,
} from '../../pages/login/authSlice';
import { datetimeToDate } from '../../utils/dateFormat';
import { useCoachingUserSearchQuery } from '../CoachingToDo/CoachingToDoSlice';
import '../CoachingToDo/coachingToDo.scss';
import {
    useCreateCoachingShoutOutMutation,
    useGetLatestShoutOutQuery,
    useGetTeamMembersDataQuery,
    useGetSystemConfigQuery
} from './coachingShoutOutSlice';
import {
    GetTeamOptions,
    allowExpansion,
    getRole,
    getUserRole,
    startBodyTemplate,
    valueBodyTemplate,
} from './coachingShoutout-service';
import { CoachingEntityTypes, CoachingTabs } from '../../utils/typeConstants';
import { useGetBadgesQuery } from '../../features/coaching/shoutOutView/shoutOutViewSlice';
import DescriptionBox from '../descriptionBox/DescriptionBox';

const MAX_CHARACTERS = 200;

type ShoutOutData = {
    employeeNumber: string;
    empName: string;
    startDate: Date | null;
    endDate: Date | null;
    shout_out_description: string;
    duration: number;
    shoutOutTitle: string;
};
interface CoachingShoutOutProps {
    receiverId?: string;
    receiverName?: string;
    coachingEntityTypeId?: number;
    coachingEntityId?: number;
    coreValueId?: number;
    visible: boolean;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    shoutOutDescription?: string;
    via?: number;
    viewOnly?: boolean;
    selectedShoutOutViewData?: any;
    result?: React.Dispatch<React.SetStateAction<any>>;
    // backgroundColor?: string;
    scorecardMetricId?: number;
}

const CoachingShoutOut: React.FC<CoachingShoutOutProps> = (props) => {
    const loggedEmpUserName = useSelector(selectCurrentUser);
    const currentEmpId = useSelector(selectCurrentEmpid);
    const empId = props.receiverId ? props.receiverId : currentEmpId;
    const empName = props.receiverName;
    const toastref = useRef<Toast>(null);
    const [isVisible, setIsVisible] = useState(false);
    const [title, setTitle] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [characterWarning, setCharacterWarning] = useState<boolean>(false);
    const [expandedRows, setExpandedRows] = useState<any>();
    const [appliesTo, setAppliesTo] = useState<string | undefined>('');
    const [coreValue, setCorevalue] = useState<number>(props.coreValueId ? props.coreValueId : 0);
    const [searchEmployeeNumber, setSearchEmployeeNumber] = useState<number>();
    const [selectedTeamOption, setSelectedTeamOption] = useState<string>('');
    const [teamOptions, setTeamOptions] = useState<any>([]);
    const [selectedEmpList, setSelectedEmpList] = useState<any>();
    const [selectedEmp, setSelectedEmp] = useState<any>(props.receiverName);
    const loggedUser = useSelector(selectCurrentEmpid);
    const userMngrRole = useSelector(selectCurrentUserManagerLevel);
    const isPseudoSupervisor = useSelector(selectIsPseudoSupervisor);
    const [shoutoutReceipientNo, setShoutoutReceipientNo] = useState<string | undefined>('');
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [searchResults, setSearchResults] = useState<Array<any>>([]);
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>('');
    const [noResultMsg, setNoResultMsg] = useState<string>('');
    const [selectedRecipient, setSelectedRecipient] = useState<any>(null);
    const [showEmployeSearchInput, setShowEmployeSearchInput] = useState<boolean>(false);
    const [createShoutOut] = useCreateCoachingShoutOutMutation();
    const [shoutOutData, setShoutOutData] = useState<any>([]);
    const [badge, setBadge] = useState<any>(null);
    const { data: badges } = useGetBadgesQuery(undefined, {});
    const { data: shoutOutDataList } = useGetLatestShoutOutQuery(
        { employeenumber: shoutoutReceipientNo },
        { skip: !shoutoutReceipientNo }
    );
    const userRole = getUserRole(useSelector(selectCurrentRole));
    const DialogueHeader = 'Shout Out';
    const searchTitle = DialogueHeader === 'Shout Out' ? 'shoutout' : '';
    const { data: userData } = useCoachingUserSearchQuery(
        {
            employeeNumber: loggedUser,
            searchEmployeeNumber,
            title: searchTitle,
            userRole,
        },
        { skip: !loggedUser || !searchEmployeeNumber || !searchTitle || !userRole }
    );
    const { data: directReportees } = useGetTeamMembersDataQuery(
        {
            employeeNo: parseInt(loggedUser, 10),
            role: getRole(userMngrRole, isPseudoSupervisor),
        },
        {
            skip: !loggedUser,
        }
    );
    const { data: employeeSearchData } = useGetActivityEmployeeSearchQuery(
        {
            loggedEmpNumber: loggedUser,
            searchedEmpNumber: debouncedSearchTerm,
            loggedEmpRole: 'shoutout_search',
        },
        {
            skip: debouncedSearchTerm.length < 5 || !loggedUser || !userMngrRole,
        }
    );
    const { data: shoutoutDurationConfig, isError, error, isLoading } = useGetSystemConfigQuery(
        { configCode: 'SHOUT_OUT_EXPIRATION_DAYS' }
    );
    console.log('systemConfig:', { shoutoutDurationConfig, isError, error, isLoading });
    const SHOUTOUT_DURATION_DAYS = parseInt(shoutoutDurationConfig?.data ?? '30', 10);

    useEffect(() => {
        let timer: any = null;
        if (searchTerm.length >= 5) {
            timer = setTimeout(() => {
                setDebouncedSearchTerm(searchTerm);
            }, 1000);
        }
        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [searchTerm]);
    useEffect(() => {
        setShoutOutData({ data: shoutOutDataList?.data || [] });
        if (props.via === CoachingTabs.CoachingInsights) {
            setShoutOutData({
                data:
                    shoutOutDataList?.data.filter(
                        (item: any) =>
                            item.coaching_entity_id === props.coachingEntityId &&
                            item.coaching_entity_type_id === CoachingEntityTypes.CoachingInsights
                    ) || [],
            });
        }
    }, [shoutOutDataList]);
    useEffect(() => {
        if (employeeSearchData) setNoResultMsg('No results found');
        else setNoResultMsg('');

        setSearchResults(employeeSearchData?.data.length > 0 ? employeeSearchData.data : []);

        if (debouncedSearchTerm.length === 0) resetState();
    }, [debouncedSearchTerm, employeeSearchData]);
    const resetState = () => {
        setSearchResults([]);
        setNoResultMsg('');
    };
    useEffect(() => {
        if (props.coachingEntityTypeId === CoachingEntityTypes.CoachingInsights) {
            setDescription((props.shoutOutDescription || '').substring(0, MAX_CHARACTERS));
        }
    }, [props.shoutOutDescription]);
    useEffect(() => {
        if (directReportees?.data?.length > 0) {
            const employeeNames = directReportees.data.map((employee: any) => ({
                label: employee.employee_name,
                value: employee.employee_number,
            }));
            setSelectedEmpList(employeeNames);
        }
    }, [directReportees]);
    useEffect(() => {
        setTeamOptions(GetTeamOptions());
    }, [selectedTeamOption]);
    useEffect(() => {
        if (!props.visible) {
            setAppliesTo('');
            setIsVisible(false);
        }
        setAppliesTo(props.receiverName);
        setShoutoutReceipientNo(props.receiverId);
    }, [props.visible, props.receiverId, props.receiverName]);

    useEffect(() => {
        // Check if userData has data and execute the logic
        if (userData?.data) {
            if (searchEmployeeNumber?.toString().length === 7) {
                if (userData.data.includes(searchEmployeeNumber)) {
                    setAppliesTo(userData.data);
                    setIsVisible(true);
                } else {
                    toastref.current?.show({
                        severity: 'warn',
                        summary: 'Warning Message',
                        detail: userData.data,
                        life: 3000,
                    });
                }
            }
        }
    }, [userData]);
    useEffect(() => {
        if (selectedTeamOption === 'myshoutout') {
            setIsVisible(true);
            setSearchEmployeeNumber(parseInt(loggedUser, 10));
            console.log(empName, props.receiverId, empId);
        } else if (selectedTeamOption === 'search') {
            setShowEmployeSearchInput(true);
        } else {
            setIsVisible(false);
            setSearchEmployeeNumber(undefined);
        }
        setShoutoutReceipientNo(props.receiverId);
        setAppliesTo(props.receiverName);
        setSelectedEmp('');
    }, [selectedTeamOption]);
    useEffect(() => {
        const exceedsLimit = description?.length > MAX_CHARACTERS;

        setCharacterWarning(exceedsLimit);
    }, [description]);

    const handleSave = () => {
        if (!shoutoutReceipientNo) {
            toast.error('Please select a recipient');
            return;
        }
        if (description?.length > MAX_CHARACTERS) {
            setCharacterWarning(true);
            return;
        }

        // Calculate dates: start date is today (no timestamp), end date is today + duration days
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Remove timestamp
        const endDate = new Date(today);
        endDate.setDate(endDate.getDate() + SHOUTOUT_DURATION_DAYS);

        createShoutOut({
            employeenumber: shoutoutReceipientNo.toString(),
            createBy: loggedUser,
            coachingEntityTypeId: props?.coachingEntityTypeId,
            coachingEntityId: props?.coachingEntityId,
            shoutOutTitle: title,
            description,
            startDate: datetimeToDate(today),
            endDate: datetimeToDate(endDate),
            duration: SHOUTOUT_DURATION_DAYS,
            coreValueId: coreValue, //props.coreValueId,
            badgeId: badge,
            scorecardMetricId: props?.scorecardMetricId,
        })
            .unwrap()
            .then((res: any) => {
                if (res.message === "duplicate shoutout") {
                    toast.warning('A Shout Out with the same description has already been created within the past week.');
                } else {
                    setTitle('');
                    setDescription('');
                    setCorevalue(0);
                    setBadge(0);
                    if (props?.result)
                        props.result("Shoutout saved successfully");
                    toast.success('Shoutout saved successfully');
                    props.setVisible(false);
                }
            })
            .catch(() => {
                toast.error('Shoutout save failed');
            });
    };

    const rowExpansionTemplate = (data: ShoutOutData) => {
        return <div> Description: {data.shout_out_description} </div>;
    };
    const footerContent = (
        //For Latest ShoutOuts
        <Accordion style={{ marginTop: '1rem' }}>
            <AccordionTab header="Latest Shout Outs">
                <div style={{ maxHeight: '300px', overflow: 'auto' }}>
                    <DataTable
                        rows={5}
                        value={shoutOutData?.data}
                        expandedRows={expandedRows}
                        onRowToggle={(e) => {
                            setExpandedRows(e.data);
                        }}
                        rowExpansionTemplate={rowExpansionTemplate}
                    >
                        <Column header="Title" field={'shout_out_title'} />
                        <Column header="Start Date" field={'start_date'} body={startBodyTemplate} />
                        <Column header="Value" field={'core_value_id'} body={valueBodyTemplate} />
                        <Column expander={allowExpansion} />
                    </DataTable>
                </div>
            </AccordionTab>
        </Accordion>
    );
    useEffect(() => {
        if (props.coreValueId) setCorevalue(props.coreValueId);
    }, [props?.coreValueId]);
    const handleSeletedOption = (option: any) => {
        const selectedEmployee = {
            employeeNumber: option.employee_number,
            employeeName: option.employee_name,
        };
        setSelectedRecipient(selectedEmployee);
        setShowEmployeSearchInput(false);
        setSearchTerm('');
        setDebouncedSearchTerm('');
        setSearchResults([]);
        setSearchEmployeeNumber(option.employee_number);
        setShoutoutReceipientNo(option.employee_number);
        setAppliesTo(option.employee_name);
    };
    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter' && searchResults.length > 0) handleSeletedOption(searchResults[0]);
    };

    const handleDescriptionChange = (value: string) => {
        setDescription(value);
    };

    return (
        <div className="justify-content-center mr-1">
            <Button
                label="Shout Out"
                icon="pi pi-megaphone"
                onClick={() => {
                    props.setVisible(true);
                    setTitle('');
                    setDescription('');
                }}
                // style={{ backgroundColor: props?.backgroundColor ? props.backgroundColor : '#3299ff', color: 'white', whiteSpace: 'nowrap' }}
                className="btn-primary"
                hidden={props?.visible}
            />
            <Dialog
                header={DialogueHeader}
                visible={props.visible}
                style={{ width: '50vw' }}
                onHide={() => {
                    props.setVisible(false);
                    setCorevalue(props.coreValueId ? props.coreValueId : 0);
                    setSelectedTeamOption('');
                }}
                footer={footerContent}
            >
                {props?.viewOnly === true && (
                    <>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <h6>Title</h6>
                                    <div style={{ marginLeft: '8px', marginTop: '5px' }}>
                                        {props?.selectedShoutOutViewData?.title}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <h6>Description</h6>
                                    <div style={{ marginLeft: '8px', marginTop: '5px' }}>
                                        <InputTextarea
                                            readOnly
                                            className="borderRadius8 w-100 todoview-readonlydesc"
                                            value={props?.selectedShoutOutViewData?.description}
                                            maxLength={4000}
                                            autoResize={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                <div className="row" style={{ minHeight: '200px' }}>
                    {props?.via !== CoachingTabs.GamePlan && props?.via !== CoachingTabs.CoachingActionPlan && (
                        <>
                            {props?.coachingEntityTypeId !== 7 && props?.viewOnly !== true && (
                                <div className="col-md-5">
                                    <h6 style={{ fontWeight: '600', fontSize: '16px' }}>Select Team</h6>
                                    <Dropdown
                                        value={selectedTeamOption}
                                        onChange={(event) => {
                                            setSelectedTeamOption(event.target.value);
                                        }}
                                        options={teamOptions}
                                        optionLabel={'name'}
                                        optionValue={'code'}
                                        placeholder="Select Team"
                                        // className="w-full md:w-14rem "
                                        className='custom-dropdown md:w-14rem'
                                    />
                                </div>
                            )}
                            {selectedTeamOption === 'myteam' && (
                                <div className="col-md-4">
                                    <div className="content">
                                        <h6 style={{ fontWeight: '600', fontSize: '16px' }}>
                                            Select Employee
                                        </h6>
                                        <Dropdown
                                            id="selectedEmp"
                                            name="Select Employee"
                                            placeholder="Select Employee"
                                            // className="rounded-start"
                                            className='custom-dropdown'
                                            options={selectedEmpList}
                                            optionValue={'value'}
                                            optionLabel={'label'}
                                            value={selectedEmp}
                                            onChange={(event) => {
                                                setSelectedEmp(event.target.value);
                                                setSearchEmployeeNumber(event.target.value);
                                                setIsVisible(true);
                                                setShoutoutReceipientNo(event.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                            {selectedTeamOption === 'search' && showEmployeSearchInput && (
                                <div className="col-md-6" style={{ marginTop: '27px', position: 'relative' }}>
                                    <div className="p-input-icon-left" style={{ width: '98%' }}>
                                        <i className="pi pi-search" />
                                        <InputText
                                            keyfilter="pnum"
                                            maxLength={10}
                                            placeholder="Search"
                                            style={{ width: '100%' }}
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                    {searchResults.length > 0 ? (
                                        <ul
                                            role="menu"
                                            className="suggest-container"
                                            style={{
                                                position: 'absolute',
                                                background: 'white',
                                                width: '91%',
                                                zIndex: '100',
                                            }}
                                        >
                                            {searchResults.map((option: any) => (
                                                <li
                                                    className="suggest-item"
                                                    key={option.employee_number}
                                                    role="menuitem"
                                                    onClick={() => {
                                                        handleSeletedOption(option);
                                                    }}
                                                    onKeyDown={handleKeyDown}
                                                >
                                                    {`${option.employee_name}-(${option.location}),${option.job_title}`}
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p style={{ marginTop: '10px' }}>{noResultMsg}</p>
                                    )}
                                </div>
                            )}
                            {selectedRecipient && !showEmployeSearchInput && selectedTeamOption === 'search' && (
                                <>
                                    <div
                                        className="col-md-5"
                                        style={{ marginTop: '27px', position: 'relative' }}
                                    >
                                        <InputText
                                            disabled
                                            placeholder="Recipient"
                                            className="w-100 borderRadius8"
                                            value={selectedRecipient.employeeName}
                                        />
                                    </div>
                                    <div
                                        className="col-md-2"
                                        style={{ marginTop: '15px', position: 'relative' }}
                                    >
                                        <Button
                                            label="Reset"
                                            // style={{ fontWeight: 400, marginTop: '12px' }}
                                            // className="p-button-outlined mb-2"
                                            className="btn-secondary btn-sm mt-3"
                                            onClick={() => {
                                                setSelectedRecipient(null);
                                                setShowEmployeSearchInput(true);
                                                setShoutoutReceipientNo(props.receiverId);
                                                setAppliesTo(props.receiverName);
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                        </>
                    )}
                    <div
                        className={
                            props?.coachingEntityTypeId === 1 ? `toDoData ${isVisible ? '' : 'hidden'}` : ''
                        }
                    >
                        <p style={{ marginTop: '.5rem' }}>Assigned To</p>
                        <p style={{ color: 'grey', marginTop: '-0.3rem' }}>{appliesTo}</p>
                        <div style={{ display: 'flex' }}>
                            <div className="col-md-4">
                                <div className="content" style={{ marginTop: '14px' }}>
                                    <h6 id="badge-dropdown">Badge</h6>
                                    <Dropdown
                                        id="value"
                                        aria-labelledby="core-value-dropdown"
                                        value={badge}
                                        options={badges?.data}
                                        onChange={(event) => {
                                            setBadge(event.target.value);
                                        }}
                                        optionValue={'coaching_shout_out_badge_id'}
                                        optionLabel={'badge_name'}
                                        placeholder="Select Value"
                                        // className="borderRadius8 w-100"
                                        className='custom-dropdown'
                                    />
                                </div>
                            </div>
                        </div>

                        <div style={{ margin: '1rem 0' }}>
                            <DescriptionBox
                                createdByLabel="Author"
                                createdByValue={loggedEmpUserName}
                                title={'Description'}
                                responseDescription={description}
                                value={description}
                                limit={200}
                                onChange={handleDescriptionChange}
                                via={CoachingTabs.shoutOut}
                            />
                            {characterWarning && (
                                <div style={{ color: 'red', marginTop: '.5rem' }}>
                                    Character limit exceeded! Maximum allowed: {MAX_CHARACTERS} characters.
                                </div>
                            )}
                        </div>
                        <div style={{ float: 'right', marginTop: '1rem' }}>
                            <Button
                                label="Cancel"
                                onClick={() => props.setVisible(false)}
                                // className="p-button-text"
                                // style={{ border: '1px solid #3299ff', marginRight: '1rem' }}
                                className="btn-secondary me-2"
                            />
                            <Button
                                label="Save"
                                onClick={() => {
                                    handleSave();
                                }}
                                autoFocus
                                disabled={!badge || !description}
                                className="btn-primary"
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};
export default CoachingShoutOut;
